var indentation_default = {
  "indentZero": "wHFxW",
  "indentOne": "muoV2",
  "indentTwo": "GjBIE",
  "indentThree": "p2rvf",
  "indentFour": "vnbCU",
  "indentFive": "wD8PX",
  "indentSix": "MYuLa"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
